'use strict';

/**
 * @ngdoc service
 * @name vTvPackageServices.TvPackageLocalStorageStoreService
 * @description Stores and retrieves information from the localStorage, based
 * on {@link vTvPackageServices.TvPackageCartStoreInterface TvPackageCartStoreInterface}
 */

angular.module('v-tv-package-services').factory('TvPackageLocalStorageStoreService', function vPackageLocalStorageStoreService(TvPackageCartStoreInterface, $q, $injector) {

    var store = new TvPackageCartStoreInterface('localStorage');

    function getItemKey(baseKey) {
        var TvPackageSelectionStateService = $injector.get('TvPackageSelectionStateService');

        return 'CART_STORE_' + baseKey + TvPackageSelectionStateService.getDomain();
    }

    store.canWrite = true;
    store.getItem = function (key) {

        return $q.when(angular.fromJson(localStorage.getItem(getItemKey(key))));
    };

    store.setItem = function (key, value) {
        if (value === null) {
            return $q.when(localStorage.removeItem(getItemKey(key)));
        }
        return $q.when(localStorage.setItem(getItemKey(key), angular.toJson(value)));
    };

    return store;
});